// extracted by mini-css-extract-plugin
module.exports = {"link":"NextLink_link__kv8HU","arrow":"NextLink_arrow__he_N5","hoverCircle":"NextLink_hoverCircle__oiwsW"};